// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ad-trigger":"_23hnz3","active":"_1ZRrAD","on-background":"_39xqid"};